import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { PaymentMethodsListWrapper } from './paymentmethods-list/PaymentMethodsList'
import AccountPage from '../../modules/accounts/AccountPage'
import { AccountHeader } from '../../modules/accounts/AccountHeader'
import { Settings } from '../../modules/accounts/components/settings/Settings'
import { Overview } from '../../modules/accounts/components/Overview'

const paymentmethodsBreadcrumbs: Array<PageLink> = [
  {
    title: 'PaymentMethod Management',
    path: '/admin/pages/paymentmethods',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Account',
    path: '/admin/pages/paymentmethods/overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const PaymentMethodsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          // path='paymentmethods'
          index
          element={
            <>
              <PageTitle breadcrumbs={paymentmethodsBreadcrumbs}>PaymentMethods list</PageTitle>
              <PaymentMethodsListWrapper />
            </>
          }
        />

        <Route
          element={
            <>
              <AccountHeader />
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                <Overview />
              </>
            }
          />
          <Route
            path='settings'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Settings</PageTitle>
                <Settings />
              </>
            }
          />
          <Route index element={<Navigate to='/admin/pages/paymentmethods/overview' />} />
        </Route>

      </Route>
      <Route index element={<Navigate to='/admin/pages/paymentmethods' />} />
    </Routes>
  )
}

export default PaymentMethodsPage
